import { useNavigate, useLocation } from "react-router-dom";
import React, { useState ,useEffect } from "react";
import axios from 'axios'


function Chatbot_History({token}) {
    const navigate = useNavigate();
   const location = useLocation();
   const dealer = location.state?.dealer;
  const enq_type = location.state?.enq_type;
  const[list,setList] = useState([]);



const fetchChatHistory = async () => {
  try {


    const customerId = dealer.cust_id || dealer.customer_id;
    const res = await axios.get(
      `https://api.krimotion.in/get-my-conversation/${enq_type}/${dealer.id}/${customerId}}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setList(res.data);
   
  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
   fetchChatHistory();

  }, []);


  return (
    <div className="container py-4">


   <div className="border-0  mb-3 px-2 py-2  ">
    
              <div className="d-flex flex-column gap-2">
    
                {/* TOP ROW: Title + Search */}
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
    
                  <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                    Chat History of  <span className="text-success">{dealer.cust_name}  </span> 
                  </h4>
    
              
    
                </div>
    
                {/* SECOND ROW: Back Button */}
                <div>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => navigate(-1)}
                  >
                    ← Back
                  </button>
                </div>
    
              </div>
    
    
            </div>
      {/* Header */}
      <div
        className="d-flex justify-content-between align-items-center px-4"
        style={{
          background: "#1E73EA",
          height: "70px",
          color: "#fff",
        }}
      >
        <div className="d-flex align-items-center">
          <h5 className="mb-0"> {dealer.dealer_name || dealer.d_name} </h5>
        </div>

        <i className="bi bi-telephone-fill fs-4"></i>
      </div>

      {/* Chat Body */}
      <div
        className="px-4 py-4"
        style={{
          height: "calc(100vh - 70px)",
          overflowY: "auto",
          background: "#f7f7f7",
        }}
      >
{/*       
 {list.map((chat) => {
  const isCustomer =
    chat.sender_type === "customer" &&
    Number(chat.sender_id) === Number(dealer.cust_id || dealer.customer_id);

      const isDealer = chat.sender_type === "dealer";

  return (
    <React.Fragment key={chat.id}>
   
      {isCustomer && (
        <div className="d-flex justify-content-end mb-3">
          <div style={{ maxWidth: "55%" }}>

          <div
  className="p-3"
  style={{
    background: "#E8F0FF",
    borderRadius: "12px",
  }}
>
  {chat.question}
</div>

        <div
  className="p-3"
  style={{
    background: "#E8F0FF",
    borderRadius: "12px",
  }}
>
  {chat.reply}
</div>

          </div>
        </div>
      )}

 
      {!isCustomer  &&  chat.reply && (
        <div className="d-flex justify-content-start mb-4">
          <div style={{ maxWidth: "55%" }}>
          

            <div
              className="p-3"
              style={{
                background: "#ECECEC",
                borderRadius: "12px",
              }}
            >
              {chat.reply}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
})} */}

{list.map((chat) => {
  const isCustomer = chat.sender_type === "customer";

  return (
    <React.Fragment key={chat.id}>
      {/* Question */}
      {chat.question && (
        <div
          className={`d-flex ${
            isCustomer ? "justify-content-end" : "justify-content-start"
          } mb-2`}
        >
          <div
            className="p-3"
            style={{
              maxWidth: "55%",
              background: isCustomer ? "#E8F0FF" : "#ECECEC",
              borderRadius: "12px",
            }}
          >
            {chat.question}
          </div>
        </div>
      )}

      {/* Reply */}
      {chat.reply && (
        <div
          className={`d-flex ${
            isCustomer ? "justify-content-start" : "justify-content-end"
          } mb-4`}
        >
          <div
            className="p-3"
            style={{
              maxWidth: "55%",
              background: isCustomer ? "#ECECEC" : "#E8F0FF",
              borderRadius: "12px",
            }}
          >
            {chat.reply}
          </div>
        </div>
      )}
    </React.Fragment>
  );
})}

          </div>
   
   
      </div>
  
  );
}

export default Chatbot_History;